import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

/* NAVIGATION DATA */
import navMenu from "../../data/navigation";

/* ICONS */
import { FaUserCog } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { HiUsers } from "react-icons/hi2";
import { MdFeedback } from "react-icons/md";

const Sidebar = ({ isOpen, isMobile, toggleSidebar }) => {
  const location = useLocation();

  /* USER ROLE */
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setUserRole(userData.designation);
    }
  }, []);

  return (
    <>
      {/* OVERLAY FOR MOBILE */}
      {isOpen && isMobile && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* SIDEBAR */}
      <div
        className={`
          ${isMobile ? "fixed" : "relative"} 
          top-0 left-0 h-full bg-black border-r border-white/20 z-30 
          transition-all duration-300 overflow-hidden
          ${isOpen ? "w-64" : "w-0"} 
          ${isMobile ? "shadow-xl" : ""}
        `}
      >
        {/* SIDEBAR HEADER */}
        <div className="h-auto flex items-center justify-between px-4 border-b border-white/20 whitespace-nowrap py-3">
          <img
            src="https://awards.lohanamahaparishad.org/logo.jpg"
            className="w-16 h-16"
            alt="LMP"
          />
          {isMobile && (
            <button
              onClick={toggleSidebar}
              className="p-1 rounded-full hover:bg-gray-100"
            >
              <IoClose className="w-6 h-6 text-black" />
            </button>
          )}
        </div>

        {/* WORKFORCE ADMIN */}
        {userRole === "SUPER-ADMIN" && (
          <div className="px-5 pt-5">
            <p className="text-xs font-ibm-regular uppercase text-white/70">
              ORGANIZATION
            </p>
            <div className="mt-3">
              <Link
                to="/workforce-admin"
                className={`flex items-center gap-3 px-4 py-2.5 mt-3 rounded-md transition-all whitespace-nowrap ${
                  location.pathname === "/workforce-admin"
                    ? "bg-white/20 text-white"
                    : "hover:bg-white/10 text-white"
                }`}
                onClick={isMobile ? toggleSidebar : undefined}
              >
                <FaUserCog
                  className={`w-4 h-4 flex-shrink-0 ${
                    location.pathname === "/workforce-admin"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                />
                <span
                  className={`text-sm font-ibm-medium ${
                    location.pathname === "/workforce-admin"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                >
                  Workforce Admin
                </span>
              </Link>
            </div>
          </div>
        )}

        {/* FORM TYPES */}
        <div className="px-5 pt-5">
          <p className="text-xs font-ibm-regular uppercase text-white/70">
            FORM TYPES
          </p>
          <div className="mt-3">
            {navMenu.map((item) => {
              const isActive = location.pathname === item.link;
              return (
                <Link
                  key={item.id}
                  to={item.link}
                  className={`flex items-center gap-3 px-4 py-2.5 mt-3 rounded-md transition-all whitespace-nowrap ${
                    isActive
                      ? "bg-white/20 text-white"
                      : "hover:bg-white/10 text-white"
                  }`}
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <item.icon
                    className={`w-4 h-4 flex-shrink-0 ${
                      isActive ? "text-white" : "text-white/60"
                    }`}
                  />
                  <span
                    className={`text-sm font-ibm-medium ${
                      isActive ? "text-white" : "text-white/60"
                    }`}
                  >
                    {item.name}
                  </span>
                </Link>
              );
            })}

            {(userRole === "SUPER-ADMIN" || userRole === "OFFICE-BEARER") && (
              <Link
                to="/rsvp"
                className={`mt-3 flex items-center gap-3 px-4 py-2.5 rounded-md transition-all whitespace-nowrap ${
                  location.pathname === "/rsvp"
                    ? "bg-white/20 text-white"
                    : "hover:bg-white/10 text-white"
                }`}
              >
                <HiUsers
                  className={`w-4 h-4 flex-shrink-0 ${
                    location.pathname === "/rsvp"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                />
                <span
                  className={`text-sm font-ibm-medium ${
                    location.pathname === "/rsvp"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                >
                  RSVP List
                </span>
              </Link>
            )}

            {(userRole === "SUPER-ADMIN" || userRole === "OFFICE-BEARER") && (
              <Link
                to="/feedback"
                className={`mt-3 flex items-center gap-3 px-4 py-2.5 rounded-md transition-all whitespace-nowrap ${
                  location.pathname === "/feedback"
                    ? "bg-white/20 text-white"
                    : "hover:bg-white/10 text-white"
                }`}
              >
                <MdFeedback
                  className={`w-4 h-4 flex-shrink-0 ${
                    location.pathname === "/feedback"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                />
                <span
                  className={`text-sm font-ibm-medium ${
                    location.pathname === "/feedback"
                      ? "text-white"
                      : "text-white/60"
                  }`}
                >
                  Feedback
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
